<template>
  <div class="paging" v-html="pageString"></div>
</template>

<script>
export default {
  data () {
    return {
      pageString: '',
      default: {
        blockSize: 10
      },
      page: {
        totalPages: 0,
        totalBlocks: 0,
        currentBlock: 0,
        startPageNum: 0,
        endPageNum: 0
      }
    }
  },
  props: {
    searchPage: Object
  },
  created () {
    this.init()
    this.print()
  },
  updated () {
    this.addClickEvent()
  },
  mounted () {
    this.addClickEvent()
  },
  methods: {
    init () {
      this.page.totalPages = Math.ceil(this.searchPage.totalRows / this.searchPage.pageSize)
      this.page.totalBlocks = Math.ceil(this.page.totalPages / this.default.blockSize)
      this.page.currentBlock = Math.floor((this.searchPage.pageNo - 1) / this.default.blockSize) + 1 // currentPage - 1
      this.page.startPageNum = (Math.floor((this.searchPage.pageNo - 1) / this.default.blockSize) * this.default.blockSize) + 1 // currentPage - 1, blockSize
      this.page.endPageNum = (this.page.startPageNum - 1) + this.default.blockSize
      // console.log(`totalPages: ${this.page.totalPages}`)
      // console.log(`totalBlocks: ${this.page.totalBlocks}`)
      // console.log(`currentBlock: ${this.page.currentBlock}`)
      // console.log(`startPageNum: ${this.page.startPageNum}`)
      // console.log(`endPageNum: ${this.page.endPageNum}`)
    },
    prePrint () {
      if (this.searchPage.pageNo > 1 && this.page.currentBlock > 1) {
        this.pageString += `<a id="${this.page.startPageNum - 1}" class="pnbtn">◀</a>`
      }
    },
    postPrint () {
      if (this.searchPage.pageNo < this.page.totalPages && this.page.endPageNum < this.page.totalPages) {
        this.pageString += `<a id="${this.page.endPageNum + 1}" class="pnbtn">▶</a>`
      }
    },
    printList () {
      for (let i = this.page.startPageNum; i <= this.page.endPageNum; i++) {
        if (i > this.page.totalPages || i > this.page.endPageNum) {
          break
        }
        if (i === this.searchPage.pageNo) {
          this.pageString += `<strong>${i}</strong>`
        } else {
          this.pageString += `<a id="${i}">${i}</a>`
        }
      }
    },
    print () {
      this.pageString = ''
      this.prePrint()
      this.printList()
      this.postPrint()
    },
    addClickEvent () {
      Array.prototype.slice.call(this.$el.querySelectorAll('a')).forEach((a) => {
        a.addEventListener('click', () => {
          this.goPagenation(a.id)
        })
      })
    },
    goPagenation (pageNo) {
      this.$emit('goPage', pageNo)
    }
  },
  watch: {
    'searchPage.pageNo' (val) {
      this.init()
      this.print()
    },
    'searchPage.totalRows' (val) {
      this.init()
      this.print()
    }
  }
}
</script>

<style>
  a {
    cursor: pointer
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Pagination.vue